<template><svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8">
  <path d="M.44.44a1.5,1.5,0,0,1,2.13,0L6.51,4.38,10.44.44a1.51,1.51,0,0,1,2.14,2.14l-5,5a1.56,1.56,0,0,1-2.18,0l-5-5A1.51,1.51,0,0,1,.44.44Z"/>
</svg></template>